import React from "react";
import { Link } from "react-router-dom";
import { Mail, Linkedin, ArrowUpRight } from "lucide-react";
import { NAV_LINKS, SITE } from "@/lib/data";
import NewsletterSignup from "@/components/NewsletterSignup";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-deep text-cream">
    <div className="mx-auto max-w-7xl px-6 py-20">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-3xl text-cream">Epic</span>
            <span className="text-xs tracking-[0.28em] uppercase text-gold font-semibold pb-1">
              Consultancy
            </span>
          </div>
          <p className="mt-6 max-w-sm text-cream/70 leading-relaxed">
            A boutique consultancy strengthening children's services through leadership,
            partnership and innovation — across the UK, the Caribbean and internationally.
          </p>
          <div className="mt-8">
            <p className="overline mb-3">Newsletter</p>
            <NewsletterSignup variant="dark" />
          </div>
        </div>

        <div className="lg:col-span-3 lg:col-start-7">
          <p className="overline mb-5">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.to === "/" ? "home" : l.to.replace("/", "")}`}
                  className="text-cream/75 hover:text-gold transition-colors duration-300"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="overline mb-5">Contact</p>
          <a
            href={`mailto:${SITE.email}`}
            data-testid="footer-email"
            className="flex items-center gap-2 text-cream/75 hover:text-gold transition-colors duration-300"
          >
            <Mail size={16} /> {SITE.email}
          </a>
          <a
            href={SITE.linkedin}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-linkedin"
            className="mt-4 flex items-center gap-2 text-cream/75 hover:text-gold transition-colors duration-300"
          >
            <Linkedin size={16} /> LinkedIn <ArrowUpRight size={14} />
          </a>
          <p className="mt-4 text-cream/60 text-sm">{SITE.website}</p>
        </div>
      </div>

      <div className="mt-16 border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-cream/50 text-sm">
          © {new Date().getFullYear()} Epic Consultancy. Led by {SITE.founder}.
        </p>
        <p className="text-cream/40 text-xs tracking-wide">
          Children's Services • Safeguarding • Service Transformation
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
